import { useEffect, useState } from 'react';
import { CloudSDK } from '@sitecore-cloudsdk/core/browser';
import '@sitecore-cloudsdk/events/browser';
import useOneTrust from './useOneTrust';
import { LayoutServicePageState } from '@sitecore-jss/sitecore-jss-nextjs';

const useCloudSDK = (
  config: { [key: string]: string },
  siteName?: string,
  pageState?: LayoutServicePageState
): void => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { consentGroups } = useOneTrust();

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      console.debug('Browser Events SDK is not initialized in development environment');
    } else if (pageState !== LayoutServicePageState.Normal) {
      console.debug('Browser Events SDK is not initialized in edit and preview modes');
    } else if (!isLoaded && consentGroups['performance']) {
      CloudSDK({
        sitecoreEdgeUrl: config.sitecoreEdgeUrl,
        sitecoreEdgeContextId: config.sitecoreEdgeContextId,
        siteName: siteName || config.sitecoreSiteName,
        enableBrowserCookie: true,
        // Replace with the top level cookie domain of the website that is being integrated e.g ".example.com" and not "www.example.com"
        cookieDomain: window.location.hostname.replace(/^www\./, ''),
      })
        .addEvents()
        .initialize();
      setIsLoaded(true);
    }
  }, [config, siteName, pageState, consentGroups, isLoaded]);
};

export default useCloudSDK;
